module.exports = __webpack_public_path__ + "icon-256-library-listing-dashboard.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/icon-256-library-listing-dashboard.png
// module id = 635
// module chunks = 11